//@ts-check
import React, { useEffect, useContext, useState, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { SignInStatusContext } from "../Basic/BasicData";
import { api } from "../Basic/ApiFetch";
import { IsNullOrEmpty, openPage } from "../Basic/SDOExtension";
import {
  showGlobalMessageBox,
  getGlobalServerConfig,
} from "../Route/RootMiddleware";

const EmailLogin = (props) => {
  // const [email, setEmail] = useState("");
  // const [userId, setUserId] = useState("");
  const { setSignInStatus, signInStatus } = useContext(SignInStatusContext);
  const [loginCount, setLoginCount] = useState(0);
  var email;
  var userId;
  var sendTime;
  //登入驗證
  const loginCheck = async () => {
    if (IsNullOrEmpty(email) || IsNullOrEmpty(userId)) {
      showGlobalMessageBox(`帳號啟用失敗! 請聯絡系統管理員`, function () {
        props.history.push("/"); //返回主頁
      });
      return;
    }
    let passData = {
      email: email,
      USER_ID: userId,
      sendTime: sendTime,
      url: getLoginPageUrl()
    };


    let url = getGlobalServerConfig().backEndUrl.get() + "Login/EmailLogin";
    let response = await api.Post(url, JSON.stringify(passData));
    if (response.ok) {
      let result = await response.json();
      if (!result.rtnModel.success) {
        showGlobalMessageBox(result.rtnModel.message, function () {
          props.history.push("/"); //返回主頁
        });
      } else {
        setSignInStatus();
        props.history.push("/Home");
      }
    }
  };

  /**
   * 取得登入頁url
   * @returns 登入頁URL
   */
  const getLoginPageUrl = () => {
    const urlObj = new URL(window.location.href);
    const pathParts = urlObj.pathname.split('/').filter(Boolean); // 過濾空白段

    if (pathParts.length > 0) {
      return `${urlObj.origin}/${pathParts[0]}/`;
    } else {
      return `${urlObj.origin}/`;
    }
  }

  // 解析查詢參數
  const location = useLocation();


  const queryParams = new URLSearchParams(location.search);

  const hasExecuted = useRef(false);
  // 透過Email超連結啟用帳戶
  useEffect(() => {
    if (!hasExecuted.current) {

      email = queryParams.get("email");
      userId = queryParams.get("USER_ID");
      sendTime = queryParams.get("sendTime");
      loginCheck();
    }
    return () => {
      hasExecuted.current = true;
    };

  }, []);

  return (
    <div></div>
  );
};

export default EmailLogin;
